import React from "react";

const Printable = () => {
  return (
    <div className="card-body">
      <div style={{ fontSize: "0.7rem" }}>
        <ul>
          <li className="text-danger">
          Registration charges Rs 5000/- (which includes entry charges, Lunch & Dinner)
          </li>
          <li className="text-danger">
          Your registration is subject to approval by {process.env.REACT_APP_FULL_SHOW_NAME}
          </li>
          <li className="text-danger">
          Your amount once received will not be refundable
          </li>
          <li className="text-danger">
          Your payment only confirm your registration.
          </li>
          <li className="text-danger">Rights of registration reserved</li>
        </ul>
      </div>
      {/* <div className="checkmark-container">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="120"
                  height="120"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="green"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="bi bi-check-circle"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M9 12l2 2 4-4" />
                </svg>
              </div> */}
    </div>
  );
};

export default Printable;
